import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanRolesResponsibilitiesSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const displayName = section && section.display_name
    ? section.display_name
    : "Roles, Responsibilities & Competency";
  const items = Array.isArray(data.items)
    ? data.items.filter((item) => (
      item
      && [item.role, item.responsibility, item.competency]
        .some((value) => String(value || "").trim() !== "")
    ))
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <thead className={styles.EmergencyPlanScenarioTableHead}>
            <tr>
              <th style={{ width: "25%" }}>Role</th>
              <th style={{ width: "50%" }}>Responsibility</th>
              <th style={{ width: "25%" }}>Competency</th>
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? items.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.role || ""}</td>
                <td>{item.responsibility || ""}</td>
                <td>{item.competency || ""}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={3}>No roles, responsibilities, or competencies available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
